module.exports = __webpack_public_path__ + "img/service-jiaoyicuohe3.6f0c58ae.svg";